import { useEffect } from "react";
import essentialOils from ".././files/essentialOils.json";
import { addDefaultImg } from '../components/imageUtils';

function EssentialOils() {

  useEffect(() => {
      document.title = "Essential Oils - Deww Botanicals";
    }, []);

  return (
    <>
      {/* // Page Header Start */}
      <div
        className="container-fluid page-header"
        style={{ backgroundImage: `url(../assets/images/essentialOil_banner.jpg)`}}
      >
        <div className="container">
          <h1 className="display-5 mb-3 animated slideInDown">Essential Oils</h1>
          <nav aria-label="breadcrumb animated slideInDown">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <a className="text-body"  Using target="_blank" without rel="noreferrer" href="javascript:void(0);">
                  Home
                </a>
              </li>
              <li className="breadcrumb-item text-dark active" aria-current="page">
                Essential Oils
              </li>
            </ol>
          </nav>
        </div>
      </div>
      {/* // Page Header End */}

      <div className="container-xxl py-4 py-md-5 container-fluid p-0 mb-5 wow fadeIn">
        <div className="container">
          <div className="row g-0 align-items-end">
            <div className="col-12">
              <p>
                Essential oils are concentrated, aromatic extracts derived from
                various parts of plants, including leaves, flowers, stems,
                roots, and seeds. These oils capture the plant's natural f
                ragrance and beneficial properties, making them widely used in
                aromatherapy, personal care, and natural remedies for their
                therapeutic eﬀects.
              </p>

              <h3>How are Essential Oils Extracted?</h3>
              <ul>
                <li>
                  Steam Distillation : The most common method, where steam is
                  passed through plant material to vaporize volatile compounds.
                  The steam is then condensed back into liquid form, separating
                  the essential oil from water.
                </li>
                <li>
                  Cold Pressing : Typically used for citrus oils, this method
                  mechanically presses the rind or peel of the fruit to release
                  the essential oil.
                </li>
                <li>
                  Solvent Extraction : Used for delicate flowers like jasmine,
                  this method involves using a solvent to dissolve the plant
                  material, which is then evaporated to leave behind the
                  essential oil.
                </li>
                <li>
                  CO₂ Extraction : This advanced technique uses pressurized
                  carbon dioxide to extract essential oils, preserving the
                  integrity of heat-sensitive compounds.
                </li>
              </ul>

              <div className="section-header text-start mb-2 mt-5 ">
                <h2 className="mb-2">Range of Essential Oils</h2>
                
              </div>
            </div>
          </div>

          <div className="tab-content">
            <div id="tab-1" className="tab-pane fade show p-0 active">
              <div className="row g-4">
                {essentialOils.map((oil, index) => {
                  return (
                    <div
                      className="col-xl-3 col-lg-3 col-md-6 col-6 col-6"
                      key={index}
                    >
                      <div className="product-item h-100">
                        <div className="position-relative bg-light overflow-hidden">
                          <img
                            className="img-fluid w-100"
                            src={oil.image}
                            onError={addDefaultImg}
                            alt={oil.name}
                          />
                          {/* <div className="bg-secondary rounded text-white position-absolute start-0 top-0 m-2 py-1 px-3 nBadge">
                            New
                          </div> */}
                        </div>
                        <div className="text-center p-1 p-md-4 mt-1">
                          <a className="d-block h6 mb-1" Using target="_blank" without rel="noreferrer" href="">
                            {oil.name}
                          </a>
                          <p>{oil.description}</p>
                          {/* <span className="text-primary me-1">$19.00</span>
                          <span className="text-body text-decoration-line-through">
                            $29.00
                          </span> */}
                        </div>
                        {/* <div className="d-flex border-top">
                                    <small className="w-100 text-center py-2">
                                    <Link to="/essentialoils" className="text-body"><i className="fa fa-eye text-primary me-2"></i> View detail</Link>
                                    </small>
                                    <small className="w-50 text-center py-2">
                                        <a className="text-body" Using target="_blank" without rel="noreferrer" href=""><i className="fa fa-shopping-bag text-primary me-2"></i>Add to cart</a>
                                    </small>
                                </div> */}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EssentialOils;
